import { useCallback, useEffect, useState } from 'react';

import { get } from '../../api';
import { useGlobalStore } from '../../lead-capture-form/state/globalStore';
import { ENTITY_TYPE } from '../../lead-capture-form/utils/constants';
import { getEntityCookiePassword } from '../../lead-capture-form/utils/helper';

export const useRLEWithLead = () => {
  const leadId = useGlobalStore((store) => store.cookie);
  const eventId = useGlobalStore((store) => store.apiEntityId);
  const [rleData, setRleData] = useState<any>({});
  const [loading, setLoading] = useState(true);

  const fetchRLE = useCallback(async () => {
    setLoading(true);
    if (eventId && leadId) {
      try {
        const entityPassword = getEntityCookiePassword(eventId, ENTITY_TYPE.EVENT);
        const finalResponse = await get(
          `/live_events/${eventId}?fields=clip_to_play&lead_uuid=${leadId}&password=${entityPassword}`,
        );
        setRleData(finalResponse);
      } catch (e) {
        console.error('Error fetching RLE data', e);
      }
    }
    setLoading(false);
  }, [eventId, leadId]);

  useEffect(() => {
    fetchRLE();
  }, [eventId, leadId, fetchRLE]);
  return { clipToPlay: rleData?.clipToPlay, loading };
};
